
import React from "react";
// import Competitioncorner from '../Components/Dashboard/Competition-corner/competition-corner';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, lazy } from 'react';
import SkeletonL from "../Components/Skeleton/Withlogin";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'

const Competitioncorner = lazy(() => import('../Components/Dashboard/Competition-corner/competition-corner')); 
const AuthCompetitioncorner = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Suspense fallback={<SkeletonL/>}>
  <Competitioncorner/>
</Suspense> : <SessionTimeoutRedirect />
}
export default AuthCompetitioncorner;


